export class DeliveryTermsRequest{
    deliveryTermsId : number;
   
    constructor(deliveryTermsId : number){
        this.deliveryTermsId = deliveryTermsId;
    }
}
